// Хак для того, чтобы компонент не терял id в Safari в момент ререндера svg
export const getFilterUrl = (id) => {
  const { pathname = '/', search = '' } = window.location;
  return `url(${pathname}${search}#${id})`;
};
